<template>
    <div class="flex flex-col">
        <header v-if="title || subTitle" class="flex flex-col gap-4">
            <h2 v-if="title" class="order-2 text-2xl">{{ title }}</h2>
            <h3 v-if="subTitle" class="font-body order-1">
                {{ subTitle }}
            </h3>
        </header>
        <div class="tile tile-blur flex flex-col gap-4">
            <div
                v-for="feature in features"
                :key="feature"
                class="flex items-center gap-2 border-b border-white/25 pb-4 last-of-type:border-none last-of-type:pb-0">
                <SvgComponent icon="check" />
                <p class="font-body">{{ feature }}</p>
            </div>
            <div v-if="price">
                <h4 class="text-4xl font-semibold">
                    €{{ price }}
                    <span v-if="unit" class="text-sm font-normal">({{ unit }})</span>
                </h4>
            </div>
            <footer v-if="button">
                <NuxtLink
                    :to="localeRoute(button.url)"
                    :target="button.openInNewTab ? '_blank' : '_self'"
                    class="btn-primary-b">
                    {{ button.title }}
                </NuxtLink>
            </footer>
        </div>
    </div>
</template>
<script lang="ts" setup>
import type { PricingItemModel } from '@su4r-frontend/api';

defineProps<PricingItemModel>();

const localeRoute = useLocaleRoute();
</script>
